import { RCP_HELPER_NAME, RCP_HELPER_TYPE } from 'app/constants';
import { RcpFullData, RcpItem } from 'app/types';

export const getHelperUrlForProvider = (rcp?: RcpFullData) =>
  rcp?.resource?.find(val => val.name === RCP_HELPER_NAME && val.type === RCP_HELPER_TYPE)?.value;

export const getProviderLabel = ({ rcpId, rcpName }: RcpItem) => {
  return `${rcpId}${rcpName ? ` - ${rcpName}` : ''}`;
};
